export const XS = 320
export const SM = 576
export const MD = 765
export const LG = 1000
export const XL = 1200
